import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'currency',
    standalone: true
})
export class CurrencyPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(value: number | string, currencyClass: string = 'currency-icon-aed'): SafeHtml {
        if (value == null || value === '') return '';

        const amount = parseFloat(value.toString());
        if (isNaN(amount)) return value.toString();

        // Format number with commas and 2 decimal places
        const formattedAmount = amount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        // Append your custom currency icon before amount
        const html = `
        <span class="currency-icon ${currencyClass}"></span>
        ${formattedAmount}
        `;
        return html;
    }
}
